/* ==========================================
   CLOVER — THEME JS (Shopify Online Store 2.0)
   Site-wide behavior: nav, reveal/tilt/magnetic
   animation engine, FAQ, quick view, Shopify
   AJAX cart, WhatsApp float, back-to-top.
   ========================================== */

/* ===== NAVBAR SCROLL STATE ===== */
function initNavbar() {
  var nav = document.querySelector('.navbar');
  if (!nav) return;
  function upd() { nav.classList.toggle('scrolled', window.scrollY > 20); }
  window.addEventListener('scroll', upd, { passive: true });
  upd();
}

/* ===== MOBILE HAMBURGER MENU ===== */
function initMobileMenu() {
  var ham = document.getElementById('nav-ham');
  var menu = document.getElementById('mob-menu');
  if (!ham || !menu) return;
  ham.addEventListener('click', function () {
    var open = menu.classList.toggle('open');
    ham.classList.toggle('open', open);
    ham.setAttribute('aria-expanded', open);
    menu.setAttribute('aria-hidden', !open);
    document.body.style.overflow = open ? 'hidden' : '';
  });
  menu.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', function () {
      menu.classList.remove('open');
      ham.classList.remove('open');
      ham.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });
  });
}

/* ===== 3D TILT ===== */
function init3DTilt() {
  document.querySelectorAll('[data-tilt]').forEach(function (el) {
    if (el.dataset.tiltInit) return;
    el.dataset.tiltInit = '1';
    var shine = document.createElement('div');
    shine.className = 'tilt-shine';
    el.style.position = 'relative';
    el.appendChild(shine);
    var intensity = parseFloat(el.getAttribute('data-tilt')) || 9;
    el.addEventListener('mousemove', function (e) {
      var r = el.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      el.style.transition = 'transform 0.08s ease';
      el.style.transform = 'perspective(900px) rotateY(' + (x * intensity * 2) + 'deg) rotateX(' + (-y * intensity * 2) + 'deg) translateY(-6px) scale(1.025)';
      shine.style.background = 'radial-gradient(circle at ' + ((x + 0.5) * 100) + '% ' + ((y + 0.5) * 100) + '%, rgba(255,255,255,0.22), rgba(255,255,255,0) 62%)';
    });
    el.addEventListener('mouseleave', function () {
      el.style.transition = 'transform 0.55s cubic-bezier(0.16,1,0.3,1)';
      el.style.transform = '';
      shine.style.background = '';
    });
  });
}

/* ===== MAGNETIC BUTTONS ===== */
function initMagnetic() {
  document.querySelectorAll('[data-mag]').forEach(function (btn) {
    if (btn.dataset.magInit) return;
    btn.dataset.magInit = '1';
    btn.addEventListener('mousemove', function (e) {
      var r = btn.getBoundingClientRect();
      var dx = e.clientX - r.left - r.width / 2;
      var dy = e.clientY - r.top - r.height / 2;
      btn.style.transition = 'transform 0.1s ease';
      btn.style.transform = 'translate(' + (dx * 0.28) + 'px, ' + (dy * 0.28) + 'px)';
    });
    btn.addEventListener('mouseleave', function () {
      btn.style.transition = 'transform 0.55s cubic-bezier(0.16,1,0.3,1)';
      btn.style.transform = '';
    });
  });
}

/* ===== SCROLL REVEAL ===== */
function initScrollReveal() {
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.06, rootMargin: '0px 0px -35px 0px' });
  document.querySelectorAll('.reveal, .reveal-fade, .stagger').forEach(function (el) { io.observe(el); });
}

/* ===== WORD REVEAL ===== */
function initWordReveal() {
  var els = document.querySelectorAll('[data-word-reveal]:not([data-word-reveal-init])');
  els.forEach(function (el) {
    el.setAttribute('data-word-reveal-init', '1');
    el.classList.add('word-reveal');
    function wrapWords(node) {
      var result = [];
      node.childNodes.forEach(function (child) {
        if (child.nodeType === 3) {
          child.textContent.split(/(\s+)/).forEach(function (part) {
            if (/^\s+$/.test(part)) { result.push(document.createTextNode(part)); }
            else if (part) {
              var span = document.createElement('span');
              span.className = 'word';
              span.textContent = part;
              result.push(span);
            }
          });
        } else {
          var clone = child.cloneNode(false);
          child.childNodes.forEach(function (sub) {
            if (sub.nodeType === 3) {
              sub.textContent.split(/(\s+)/).forEach(function (part) {
                if (/^\s+$/.test(part)) { clone.appendChild(document.createTextNode(part)); }
                else if (part) {
                  var s = document.createElement('span');
                  s.className = 'word';
                  s.textContent = part;
                  clone.appendChild(s);
                }
              });
            } else { clone.appendChild(sub.cloneNode(true)); }
          });
          result.push(clone);
        }
      });
      return result;
    }
    var nodes = wrapWords(el);
    el.innerHTML = '';
    nodes.forEach(function (n) { el.appendChild(n); });
    el.querySelectorAll('.word').forEach(function (w, i) { w.style.transitionDelay = (i * 55) + 'ms'; });
  });
  if (!els.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { io.observe(el); });
}

/* ===== SCRAMBLE COUNTERS ===== */
function scrambleNum(el, target, dur) {
  var digits = '0123456789';
  var suffix = el.dataset.suffix || '';
  var comma = el.dataset.comma === 'true';
  var t0 = performance.now();
  function tick(t) {
    var p = Math.min((t - t0) / dur, 1);
    var eased = 1 - Math.pow(1 - p, 4);
    var curr = Math.floor(eased * target);
    if (p < 0.65) {
      var s = String(curr).split('').map(function (c) {
        return Math.random() > p * 1.5 ? digits[Math.floor(Math.random() * 10)] : c;
      }).join('');
      el.textContent = s + suffix;
    } else {
      el.textContent = (comma ? curr.toLocaleString('en-IN') : curr) + suffix;
    }
    if (p < 1) requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
}
function initScrambleCounters() {
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.querySelectorAll('[data-count]').forEach(function (el) {
          scrambleNum(el, parseInt(el.dataset.count, 10), 2400);
        });
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.3 });
  document.querySelectorAll('.counters-grid').forEach(function (el) { io.observe(el); });
}

/* ===== PATTERN AUTO-MARQUEE ===== */
function initPatternMarquee() {
  var track = document.querySelector('.pattern-marquee-track');
  if (!track || track.dataset.marqueeInit) return;
  track.dataset.marqueeInit = '1';
  var originals = Array.prototype.slice.call(track.children);
  originals.forEach(function (t) { track.appendChild(t.cloneNode(true)); });
  var x = 0, paused = false;
  var speed = 0.55;
  var wrap = track.parentElement;
  wrap.addEventListener('mouseenter', function () { paused = true; });
  wrap.addEventListener('mouseleave', function () { paused = false; });
  function run() {
    if (!paused) {
      x += speed;
      var half = track.scrollWidth / 2;
      if (x >= half) x = 0;
      track.style.transform = 'translateX(-' + x.toFixed(2) + 'px)';
    }
    requestAnimationFrame(run);
  }
  run();
}

/* ===== FAQ ACCORDION ===== */
function initFAQ() {
  document.querySelectorAll('.faq-item').forEach(function (item) {
    if (item.dataset.faqInit) return;
    item.dataset.faqInit = '1';
    var trigger = item.querySelector('.faq-trigger');
    var content = item.querySelector('.faq-content');
    if (!trigger || !content) return;
    trigger.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(function (o) {
        o.classList.remove('open');
        o.querySelector('.faq-content').style.maxHeight = '0';
      });
      if (!isOpen) {
        item.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
}

/* ===== WHATSAPP FLOAT ===== */
function initWhatsApp() {
  if (document.querySelector('.wa-btn')) return;
  var num = (window.themeSettings && window.themeSettings.whatsapp) || '';
  if (!num) return;
  var a = document.createElement('a');
  a.className = 'wa-btn';
  a.href = 'https://wa.me/' + num + '?text=' + encodeURIComponent('Hi, I\'d like to know more about your products.');
  a.target = '_blank'; a.rel = 'noopener';
  a.setAttribute('aria-label', 'Chat on WhatsApp');
  a.innerHTML = '<svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.126 1.535 5.858L.057 23.428a.5.5 0 0 0 .609.61l5.733-1.496A11.943 11.943 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.907 0-3.693-.504-5.234-1.385l-.376-.215-3.893 1.017 1.019-3.78-.23-.388A9.956 9.956 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/></svg><span class="wa-tooltip">Chat on WhatsApp</span>';
  document.body.appendChild(a);
}

/* ===== BACK TO TOP ===== */
function initBackToTop() {
  if (document.querySelector('.back-top')) return;
  var btn = document.createElement('button');
  btn.className = 'back-top';
  btn.type = 'button';
  btn.setAttribute('aria-label', 'Back to top');
  btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M9 14V4M4 9l5-5 5 5"/></svg>';
  document.body.appendChild(btn);
  btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  window.addEventListener('scroll', function () {
    btn.classList.toggle('visible', window.scrollY > window.innerHeight * 0.5);
  }, { passive: true });
}

/* ==========================================
   SHOPIFY AJAX CART
   ========================================== */
var CloverCart = (function () {
  var cartAddUrl = (document.body && document.body.dataset.cartAddUrl) || '/cart/add.js';
  var cartUrl = (document.body && document.body.dataset.cartUrl) || '/cart';
  var cartJsUrl = (document.body && document.body.dataset.cartJsUrl) || '/cart.js';
  var toastEl = null, toastTimer = null;

  function showToast(name, message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cc-toast';
      toastEl.style.cssText = 'position:fixed;bottom:7.5rem;right:1.5rem;z-index:2100;background:#1A1A1A;color:white;padding:.875rem 1.25rem;border-radius:12px;box-shadow:0 8px 30px rgba(0,0,0,.25);font-size:.875rem;display:flex;align-items:center;gap:1rem;max-width:320px;transform:translateY(12px) scale(.94);opacity:0;transition:transform .3s cubic-bezier(0.16,1,0.3,1),opacity .3s;pointer-events:none;font-family:var(--font)';
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span style="flex:1;line-height:1.45"><strong style="display:block;font-size:.9375rem">' + (message || '✓ Added to Cart') + '</strong><span style="color:rgba(255,255,255,.6)">' + name + '</span></span><a href="' + cartUrl + '" style="color:#45C17A;font-weight:700;white-space:nowrap;font-size:.875rem">View Cart →</a>';
    requestAnimationFrame(function () {
      toastEl.style.transform = 'translateY(0) scale(1)';
      toastEl.style.opacity = '1';
      toastEl.style.pointerEvents = 'auto';
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.style.transform = 'translateY(8px) scale(.95)';
      toastEl.style.opacity = '0';
      toastEl.style.pointerEvents = 'none';
    }, 3200);
  }

  function updateBadge() {
    return fetch(cartJsUrl, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-badge').forEach(function (b) {
          b.textContent = cart.item_count;
          b.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
        return cart;
      })
      .catch(function () {});
  }

  function add(variantId, qty, name, sellingPlanId) {
    var item = { id: variantId, quantity: qty || 1 };
    if (sellingPlanId) item.selling_plan = sellingPlanId;
    return fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          showToast(res.data && res.data.description ? res.data.description : 'Could not add this item', '⚠ Not Added');
          return Promise.reject(res.data);
        }
        updateBadge();
        showToast(name || (res.data.items && res.data.items[0] && res.data.items[0].product_title) || 'Item');
        document.dispatchEvent(new CustomEvent('clover:cart:add', { detail: res.data }));
        return res.data;
      });
  }

  document.addEventListener('DOMContentLoaded', updateBadge);

  return { add: add, updateBadge: updateBadge, showToast: showToast };
})();

/* ===== ADD-TO-CART BUTTON PULSE ===== */
function initAddToOrderBtns() {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-add-btn');
    if (!btn || btn.disabled) return;
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    e.preventDefault();
    e.stopPropagation();
    var qty = parseInt(btn.dataset.qty || '1', 10);
    var name = btn.dataset.name || '';
    var sellingPlanId = btn.dataset.sellingPlan || null;
    var orig = btn.textContent;
    btn.disabled = true;
    CloverCart.add(variantId, qty, name, sellingPlanId).then(function () {
      btn.textContent = '✓ Added!';
      btn.style.background = '#16a34a';
      btn.style.transform = 'scale(0.96)';
      setTimeout(function () {
        btn.textContent = orig;
        btn.style.background = '';
        btn.style.transform = '';
        btn.disabled = false;
      }, 1600);
    }).catch(function () {
      btn.textContent = orig;
      btn.disabled = false;
    });
  });
}

/* ==========================================
   QUICK VIEW MODAL (real product/variant data)
   ========================================== */
function initQuickView() {
  var overlay = null;

  function money(cents) {
    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  }

  function openModal(p, truePrice) {
    var variant = p.variants && p.variants[0];
    var compareAt = variant && variant.compare_at_price;
    var saving = compareAt && compareAt > variant.price ? Math.round((compareAt - variant.price) / compareAt * 100) : 0;
    var img = (p.featured_image && (p.featured_image.src || p.featured_image)) || (p.images && p.images[0]);
    var hasDepositPlan = !!(truePrice && truePrice > 0);
    var addLabel = hasDepositPlan ? ('Book at Only ' + money(variant.price)) : 'Add to Cart';
    var displayPrice = hasDepositPlan ? truePrice : variant.price;

    if (!overlay) {
      overlay = document.createElement('div');
      overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:2000;display:flex;align-items:flex-end;justify-content:center;backdrop-filter:blur(3px);opacity:0;transition:opacity .3s';
      document.body.appendChild(overlay);
      overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
    }

    overlay.innerHTML = '<div id="qv-box" style="background:var(--card);border-radius:24px 24px 0 0;width:100%;max-width:680px;max-height:88vh;overflow-y:auto;transform:translateY(100%);transition:transform .42s cubic-bezier(0.16,1,0.3,1);padding:2rem">'
      + '<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:1.5rem">'
      + '<span style="font-size:.75rem;font-weight:700;color:var(--green);letter-spacing:.1em;text-transform:uppercase">' + (p.type || '') + '</span>'
      + '<button type="button" data-qv-close style="width:34px;height:34px;border-radius:50%;background:var(--border-light);border:none;cursor:pointer;font-size:1rem;display:flex;align-items:center;justify-content:center">✕</button>'
      + '</div>'
      + '<div style="display:grid;grid-template-columns:1fr 1fr;gap:1.5rem;align-items:start">'
      + '<div style="aspect-ratio:1;border-radius:var(--r-lg);overflow:hidden;background:#f0ede8">' + (img ? '<img src="' + img + '" alt="' + (p.title || '') + '" style="width:100%;height:100%;object-fit:cover">' : '') + '</div>'
      + '<div>'
      + '<h3 style="font-size:1.375rem;font-weight:900;line-height:1.2;margin-bottom:.25rem">' + p.title + '</h3>'
      + '<div style="font-size:.8125rem;color:var(--text-muted);margin-bottom:1rem">' + (p.vendor || '') + '</div>'
      + '<div style="display:flex;align-items:baseline;gap:.75rem;margin-bottom:1.25rem"><span style="font-size:1.5rem;font-weight:900;color:var(--green)">' + money(displayPrice) + '</span>'
      + (!hasDepositPlan && saving ? '<span style="font-size:.9375rem;color:var(--text-muted);text-decoration:line-through">' + money(compareAt) + '</span><span style="font-size:.8125rem;font-weight:700;color:#16a34a;background:#dcfce7;padding:.15rem .5rem;border-radius:4px">Save ' + saving + '%</span>' : '')
      + '</div>'
      + '<div style="font-size:.875rem;color:var(--text-mid);line-height:1.6;margin-bottom:1.5rem">' + (p.description ? p.description.replace(/<[^>]*>/g, '').slice(0, 180) : '') + '</div>'
      + (hasDepositPlan ? '<div style="font-size:.75rem;font-weight:700;color:var(--green);margin-bottom:.5rem">Book the order by paying only 15%</div>' : '')
      + '<button type="button" class="product-add-btn" data-variant-id="' + variant.id + '" data-name="' + p.title.replace(/"/g, '&quot;') + '" data-qty="1" style="width:100%;margin-bottom:.75rem">' + addLabel + '</button>'
      + '<a href="' + p.url + '" style="display:block;text-align:center;font-size:.875rem;font-weight:600;color:var(--text-muted)">View full details →</a>'
      + '</div></div></div>';

    overlay.style.display = 'flex';
    setTimeout(function () {
      overlay.style.opacity = '1';
      var b = document.getElementById('qv-box');
      if (b) b.style.transform = 'translateY(0)';
    }, 20);
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    if (!overlay) return;
    var box = document.getElementById('qv-box');
    if (box) box.style.transform = 'translateY(100%)';
    overlay.style.opacity = '0';
    setTimeout(function () { overlay.style.display = 'none'; document.body.style.overflow = ''; }, 380);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-qv-btn[data-product]');
    if (btn) {
      try { openModal(JSON.parse(btn.dataset.product), parseInt(btn.dataset.truePrice, 10) || 0); } catch (err) { /* ignore malformed payload */ }
    }
    if (e.target.closest('[data-qv-close]')) closeModal();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
}

/* ===== INIT ALL ===== */
function initTheme() {
  initNavbar();
  initMobileMenu();
  initScrollReveal();
  initWordReveal();
  initScrambleCounters();
  init3DTilt();
  initMagnetic();
  initPatternMarquee();
  initFAQ();
  initBackToTop();
  initAddToOrderBtns();
  initQuickView();
  initWhatsApp();
}
document.addEventListener('DOMContentLoaded', initTheme);
document.addEventListener('shopify:section:load', initTheme);
